import { useSetRecoilState } from 'recoil';

import { confirmedGuardianDocument } from '../atoms/confirmedGuardianDocument';

export default function useSetConfirmedGuardianDocument() {
  return useSetRecoilState(confirmedGuardianDocument);
}
